import { Outlet } from 'react-router-dom';

export default function DebtLayout() {
  return <Outlet />;
}
